module.exports = __webpack_public_path__ + "img/hud-02.f1b1b688.png";